// extracted by mini-css-extract-plugin
export default {"text":"Avatar_text__M2+f9","modal":"Avatar_modal__jwmmr","modal-content":"Avatar_modal-content__Gf2Ai"};